module.exports = __webpack_public_path__ + "src/assets/images/HERO-Logo.png?d0502c46d59750a8a9a22abab1926d25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HERO-Logo.png
// module id = 976
// module chunks = 1